<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header> Histórico </v-expansion-panel-header>
      <v-expansion-panel-content>
        Histórico de atendimento será carregado aqui
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: 'history',
  }
</script>